import { errorHandler } from "src/app/util/errorHandler";
import { environment } from "src/environments/environment";
import { authData } from "src/app/util/auth";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-election-application",
  templateUrl: "./election-application.component.html",
})
export class ElectionApplicationComponent implements OnInit {
  constructor(private httpClient: HttpClient, private router: Router) {}

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + authData().Token,
    }),
  };

  refreshing = true;
  elections: any = [];
  notification = {};

  ngOnInit(): void {
    this.refreshing = true;
    const baseUrl = `${environment.BASE_URL}/elections/eligibleApplicationsElections`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe({
      next: (res: any) => {
        if (res.Success) {
          this.elections = res.Data;
        } else {
          this.notification = errorHandler({
            error: true,
            message: res.Message,
          });
        }
      },
      error: (err) => {
        this.notification = errorHandler(err);
      },
      complete: () => {
        this.refreshing = false;
      },
    });
  }
}
